module.exports = __webpack_public_path__ + "img/twice.3dabc726.jpg";